import { Component } from '@angular/core';
import { SelectOption, CustomSelectComponent } from '../../../shared-components/custom-select/custom-select.component';
import { TranslateService } from '../../../services/translate/translate.service';
import { ValidationRule } from '../../../models/validation-rules/validation-rules';

@Component({
	selector: 'app-selects',
	templateUrl: './selects.component.html',
	styleUrls: ['./selects.component.scss'],
	standalone: false,
})
export class SelectsComponent {
	singleValue: string = '';
	multipleValue: string = '';
	validatedValue: string = '';
	disabledValue: string = '';

	constructor(private translateService: TranslateService) {}

	private get rules() {
		return CustomSelectComponent.createRules(this.translateService, undefined);
	}

	validationValid = false;

	onValidationChange(validation: { isValid: boolean; errors: string[] }): void {
		this.validationValid = validation.isValid;
	}

	simpleOptions: SelectOption[] = [
		{ label: 'Google', value: 'google' },
		{ label: 'Apple', value: 'apple' },
		{ label: 'Microsoft', value: 'microsoft' },
		{ label: 'Amazon', value: 'amazon' },
		{ label: 'Meta', value: 'meta' },
		{ label: 'Netflix', value: 'netflix' },
	];

	options: SelectOption[] = Array.from({ length: 10000 }, (_, i) => ({
		label: `Option ${i + 1}`,
		value: `option-${i + 1}`,
	}));

	doubleOptions: SelectOption[] = [
		{ label: 'Google', value: 'google' },
		{ label: 'Apple', value: 'apple', disabled: true },
	];

	// Example validation rules using the helper methods
	get validationRules(): ValidationRule[] {
		return [
			// Require at least one selection
			this.rules.required(),

			// Require minimum 2 selections
			this.rules.minSelections(2),

			// Limit to maximum 4 selections
			this.rules.maxSelections(4),

			// Custom rule: cannot select both Google and Apple together
			this.rules.custom(
				(value) => {
					if (Array.isArray(value)) {
						const hasGoogle = value.includes('google');
						const hasApple = value.includes('apple');
						return !(hasGoogle && hasApple);
					}
					return true;
				},
				'Google and Apple cannot be selected together (business rule example)',
				'no-google-apple'
			),
		];
	}

	onSelectionChange(type: string, value: any): void {
		console.log('Selection changed:', type, value);

		const displayValue = Array.isArray(value) ? value.join(', ') : value;

		if (type === 'single') {
			this.singleValue = displayValue;
		} else if (type === 'multiple') {
			this.multipleValue = displayValue;
		} else if (type === 'validated') {
			this.validatedValue = displayValue;
		}
	}
}
